import { createContext } from "react";
import { Locale } from "../api/dtos";

interface ILocaleContext {
    data: Locale | undefined
}

const LocaleContext = createContext<ILocaleContext>({
    data: undefined
});

export default LocaleContext;